import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-social">
          <Link to="/" className="social-link" onClick={toTop}>
            HOME
          </Link>
        </div>
        <Link to="/" className="logo" onClick={toTop} aria-label="Hound & Home home">
          <img src="/head/hound-home-mark.svg" alt="" />
        </Link>
        <div className="header-actions">
          <Link to="/cartpage" className="cart-btn" aria-label="Cart">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>

      <nav className="main-nav">
        <Link to="/shop" className="nav-link" onClick={toTop}>
          SHOP ALL
        </Link>
        <Link to="/about" className="nav-link" onClick={toTop}>
          ABOUT US
        </Link>
        <Link to="/contact" className="nav-link" onClick={toTop}>
          CONTACT US
        </Link>
        <details className="more-menu">
          <summary className="nav-link">MORE</summary>
          <div className="more-menu__panel">
            <Link to="/policies" onClick={toTop}>ALL POLICIES</Link>
            <Link to="/faqs" onClick={toTop}>FAQS</Link>
            <Link to="/shipping" onClick={toTop}>SHIPPING POLICY</Link>
            <Link to="/returns" onClick={toTop}>RETURNS POLICY</Link>
            <Link to="/privacy" onClick={toTop}>PRIVACY POLICY</Link>
            <Link to="/cookies" onClick={toTop}>COOKIE POLICY</Link>
            <Link to="/terms" onClick={toTop}>TERMS OF SERVICE</Link>
            <Link to="/payment-security" onClick={toTop}>PAYMENT &amp; SECURITY</Link>
            <Link to="/accessibility" onClick={toTop}>ACCESSIBILITY</Link>
          </div>
        </details>
      </nav>
    </header>
  );
}

export default Header;
